import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7a20e6ba")

_pushScopeId("data-v-7a20e6ba")
const _hoisted_1 = { class: "active-filters" }
const _hoisted_2 = { class: "filters" }
const _hoisted_3 = {
  key: 0,
  class: "notFoundEstablishment"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "Nenhum estabelecimento encontrado :(", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_select_option = _resolveComponent("ion-select-option")
  const _component_ion_select = _resolveComponent("ion-select")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_chip = _resolveComponent("ion-chip")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_item_group = _resolveComponent("ion-item-group")
  const _component_EstablishmentCardSkeleton = _resolveComponent("EstablishmentCardSkeleton")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_establishment_card = _resolveComponent("establishment-card")
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")
  const _component_network_error = _resolveComponent("network-error")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", null, [
        _createVNode(_component_ion_select, {
          modelValue: _ctx.itemsSortBy,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.itemsSortBy = $event)),
          placeholder: _ctx.search.itemsSortBy.name,
          interface: "action-sheet",
          "cancel-text": "Fechar"
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortBy, (sort) => {
              return (_openBlock(), _createBlock(_component_ion_select_option, {
                key: sort.id,
                value: sort
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(sort.name) + " ", 1),
                  _createVNode(_component_ion_icon, {
                    icon: sort.icon
                  }, null, 8, ["icon"])
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"])
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_ion_item_group, null, {
          default: _withId(() => [
            _createVNode(_component_ion_item, { lines: "none" }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.search.categories, (categories) => {
                  return (_openBlock(), _createBlock(_component_ion_chip, {
                    key: categories.index
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(categories.name), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.closeCircle,
                        onClick: ($event: any) => (_ctx.removeFilterCategories(categories))
                      }, null, 8, ["icon", "onClick"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.search.searchFilters, (filters) => {
                  return (_openBlock(), _createBlock(_component_ion_chip, {
                    key: filters.index
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(filters.name), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.closeCircle,
                        onClick: ($event: any) => (_ctx.removeFilterFilters(filters))
                      }, null, 8, ["icon", "onClick"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.search.payments, (payments) => {
                  return (_openBlock(), _createBlock(_component_ion_chip, {
                    key: payments.index
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(payments.name), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.closeCircle,
                        onClick: ($event: any) => (_ctx.removeFilterPayment(payments))
                      }, null, 8, ["icon", "onClick"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.loadingRef)
      ? (_openBlock(), _createBlock(_component_ion_grid, { key: 0 }, {
          default: _withId(() => [
            _createVNode(_component_ion_row, null, {
              default: _withId(() => [
                (_openBlock(), _createBlock(_Fragment, null, _renderList(10, (i) => {
                  return _createVNode(_component_ion_col, {
                    key: i,
                    "size-xs": "12",
                    "size-sm": "12",
                    "size-md": "6",
                    "size-lg": "6",
                    "size-xl": "4"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_EstablishmentCardSkeleton)
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (!_ctx.occurredErrorRef)
        ? (_openBlock(), _createBlock(_component_ion_grid, { key: 1 }, {
            default: _withId(() => [
              _createVNode(_component_ion_row, null, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.establishmentsRef, (establishment) => {
                    return (_openBlock(), _createBlock(_component_ion_col, {
                      key: establishment.id,
                      class: "no-padding",
                      "size-xs": "12",
                      "size-sm": "12",
                      "size-md": "6",
                      "size-lg": "6",
                      "size-xl": "4",
                      onClick: ($event: any) => (_ctx.goToEstablishment(establishment.id))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_establishment_card, { establishment: establishment }, null, 8, ["establishment"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_infinite_scroll, {
                onIonInfinite: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getNextEstablishments($event)))
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_infinite_scroll_content, { "loading-ref-spinner": "dots" })
                ]),
                _: 1
              }),
              (_ctx.establishmentsRef.length == 0)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _hoisted_4
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
    (_ctx.occurredErrorRef)
      ? (_openBlock(), _createBlock(_component_network_error, {
          key: 2,
          refresh: _ctx.getEstablishments
        }, null, 8, ["refresh"]))
      : _createCommentVNode("", true)
  ], 64))
})